module.exports = __webpack_public_path__ + "static/media/winZoleTwoAces_1.ef3d4393.svg";